<template>
  <div>
      <div class="choice" :style="{height:fullpage + 'px'}"> 
          <div class="choice-a">
             <router-link :to="{ name:'product-select', params: { cate: '1' }}" class="choice-truck">
                  <span>加热器</span>
              </router-link>
              <router-link :to="{ name:'product-select', params: { cate: '3' }}" class="choice-truck">
                  <span>空调</span>
              </router-link>
          </div>
      </div>
  </div>
</template>
<script>
    export default{
        data(){
            return{
              fullpage:document.documentElement.clientHeight,
             
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/mobile/tation/ProductCategory.vue